import $ from 'jquery';
import { activate } from 'Util/activate';
import { publish, subscribe } from 'Util/pubsub';
import Mustache from 'mustache';

const selectors = {
	toggle: '.js-uml-toggle',
	toggleDisplay: '.js-uml-toggle-display',
	resourceItem: '.js-resources__item',
	resourceTitle: '.js-resources__title',
	list: '.js-uml-list', // basket
	item: '.js-uml-item', //item in basket
	listing: '.js-uml-listing', //ul
	delete: '.js-uml-delete',
	basketSource: '.js-basket-source'
};

const dataSelectors = {
	id: 'uml-id',
	placeholderId: 'uml-placeholder-id',
	method: 'uml-method',
	fetchUrl: 'uml-fetch-url',
	listTemplate: 'uml-list-template',
	toggleUrl: 'uml-toggle-url',
	cache: 'uml-list-cache',
	idCache: 'uml-list-id-cache',
	update: 'uml-update-timeout',
	updateUrl: 'uml-update-url',
	listId: 'uml-list-id'
};

const subscriptions = {
	dragStart: '/dragsort/start',
	dragStop: '/dragsort/stop',
	localAdd: '/uml/local/add',
	localRemove: '/uml/local/remove',
	localAdded: '/uml/local/added',
	localRemoved: '/uml/local/removed'
};

const publications = {
	error: '/status/error',
	success: '/status/success',
	lazyload: '/lazyload/ajax',
	localAdded: '/uml/local/added',
	localRemoved: '/uml/local/removed'
};

const classes = {
	busy: 'is-busy',
	allowAnimations: 'allow-animations',
	success: 'success',
	error: 'error'
};

const Methods = {
	REMOTE: 'remote',
	LOCAL: 'local'
};

const localStorageSupport = window.localStorage && window.localStorage.getItem;

const module = {
	init: {
		init() {
			module.init._events();
			module.init._subscriptions();
			module.init._localTogglesDisplay();
			module.init.listsDisplay();
			module.init._cache();
		},

		_events() {
			$(document)
				.on(activate.event, selectors.toggle, activate(module.toggle.event))
				.on(activate.event, selectors.delete, activate(module.update.deleteEvent));
		},

		_subscriptions() {
			subscribe(subscriptions.dragStart, module.update.sortStart);
			subscribe(subscriptions.dragStop, module.update.sortStop);
			subscribe(subscriptions.localAdd, module.toggle.localAdd);
			subscribe(subscriptions.localRemove, module.toggle.localRemove);
			subscribe(subscriptions.localAdded, module.update.showPlaceholderIfListEmptySubscription);
			subscribe(subscriptions.localRemoved, module.update.showPlaceholderIfListEmptySubscription);
		},

		_localTogglesDisplay() {
			const $toggles = $(selectors.toggle).filter(module.util.isLocal);
			$toggles.each((i, el) => {
				const $toggle = $toggles.eq(i);
				const value = module.localStorage.getToggleValue($toggle);
				module.toggle.updateDisplay($toggle, value, true);
			});
		},

		listsDisplay() {
			const $lists = $(selectors.list);
			const $basketSource = $(selectors.basketSource);
			$lists.each((i, el) => {
				const $list = $lists.eq(i);
				//module.update.initListDisplay($list);
			});
		},

		_cache() {
			const $lists = $(selectors.list);
			$lists.each((i, el) => {
				const $list = $lists.eq(i);
				module.cache.create($list);
			});
		}
	},

	toggle: {
		/* 
		When the user toggles the state of a local item, we check
		the state of its list in localStorage and either add it to
		the start of the list or remove it from the list.
		*/
		getMethod($toggle) {
			let method = Methods.LOCAL;
			$toggle.data(dataSelectors.method, method);
			return method;
		},

		event(e) {
			const $toggle = $(e.target).closest(selectors.toggle);
			e.preventDefault();
			module.toggle._toggle($toggle);
		},

		_toggle($toggle) {
			module.toggle._local($toggle);
		},

		_local($toggle) {
			const id = $toggle.data(dataSelectors.id);
			const listId = $toggle.data(dataSelectors.listId);
			const list = module.localStorage.getList(listId);
			const index = list.indexOf(id);
			if (index === -1) {
				module.toggle.localAdd(listId, id, $toggle);
			} else {
				module.toggle.localRemove(listId, id);
			}
		},

		localAdd(listId, id, $toggle) {
			const list = module.localStorage.getList(listId);
			window.dataLayer = window.dataLayer || [];

			// If it's not already in the list
			if (list.indexOf(id) === -1) {
				// Add to start of array
				list.unshift(id);
			}
			module.localStorage.setList(listId, list);
			publish(publications.localAdded, [listId, id]);
			const basketItem = $toggle.closest(selectors.resourceItem).find(selectors.resourceTitle).text();
			dataLayer.push({
				event: 'customEvent',
				eventData: {
					category: 'Resource Centre',
					action: 'Add To Basket',
					label: basketItem
				}
			});
			module.toggle.updateDisplayById(id, true, false);
		},

		localRemove(listId, id) {
			const list = module.localStorage.getList(listId);
			const index = list.indexOf(id);
			// If it's currently in the list
			if (index !== -1) {
				// Remove from array
				list.splice(index, 1);
			}
			module.localStorage.setList(listId, list);
			publish(publications.localRemoved, [listId, id]);
			module.toggle.updateDisplayById(id, false, false);
		},

		_complete: $toggle => () => {
			$toggle.removeClass(classes.busy);
		},

		_success: $toggle => (data, status, response) => {
			if (data.Success === true) {
				module.toggle._updateSharedDisplays($toggle, data.Stored);
				const basketItem = $toggle.closest(selectors.resourceItem).find(selectors.resourceTitle).text();
				dataLayer.push({
					event: 'customEvent',
					eventData: {
						category: 'Resource Centre',
						action: 'Add To Basket',
						label: basketItem
					}
				});
			} else {
				module.toggle._error($toggle)(response, status, data);
			}
		},

		_error: $toggle => (...args) => {
			console.error(args);
			publish(publications.error, 'Oops, an error occurred');
		},

		_updateSharedDisplays($toggle, stored) {
			const $toggles = module.toggle._getSharedToggles($toggle);
			$toggles.each((i, el) => {
				const $thisToggle = $toggles.eq(i);
				module.toggle.updateDisplay($thisToggle, stored);
			});
		},

		updateDisplay($toggle, stored, initial) {
			let $display = $toggle.find(selectors.toggleDisplay);
			if ($display.length === 0) $display = $toggle;
			const wasStored = $display.attr('aria-pressed') === 'true';
			if (stored === wasStored) return;
			$display.attr('aria-pressed', !!stored);
			if (!initial && !$display.hasClass(classes.allowAnimations)) {
				$display.addClass(classes.allowAnimations);
			}
		},

		updateDisplayById(id, stored, initial) {
			const $toggles = module.toggle.getTogglesById(id);
			$toggles.each((i, el) => {
				const $toggle = $toggles.eq(i);
				module.toggle.updateDisplay($toggle, stored, initial);
			});
		},

		_getSharedToggles($toggle) {
			return module.toggle._getSharedTogglesLocal($toggle);
		},

		_getSharedTogglesLocal($toggle) {
			const id = $toggle.data(dataSelectors.id);
			return module.toggle.getTogglesById(id);
		},

		getTogglesById(id) {
			return $(selectors.toggle).filter(`[data-${dataSelectors.id}="${id}"]`);
		}
	},

	update: {
		/*
		When managing a local update list as a whole, after any
		change we overwrite the list in localStorage with its state
		according to the markup.
		*/
		getMethod($list) {
			let method = Methods.LOCAL;
			$list.data(dataSelectors.method, method);
			return method;
		},

		_update($list) {
			module.update._local($list);
		},

		getIds($list) {
			let testing = $list.find(selectors.item).map((i, el) => $(el).data(dataSelectors.id)).get()
			return $list.find(selectors.item).map((i, el) => $(el).data(dataSelectors.id)).get();
		},

		_compareIds(listA, listB) {
			if (!Array.isArray(listA) || !Array.isArray(listB) || listA.length !== listB.length) return false;
			return listA.every((id, i) => id === listB[i]);
		},

		_getMissingIds(listA, listB) {
			return listA.filter(id => listB.indexOf(id) === -1);
		},

		_complete: $list => () => {
			$list.removeClass(classes.busy);
		},

		_success: $list => responseData => {
			if (!module.update.showPlaceholderIfListEmpty($list, responseData.ids)) {
				module.update._trim($list, responseData.result);
				module.cache.create($list);
				publish(publications.success, 'Saved');
			}
		},

		_error: $list => () => {
			module.cache.restore($list);
			publish(publications.error, 'Oops, there was a problem');
		},

		_trim($list, ids) {
			const $items = $list.find(selectors.item);
			if ($items.length > ids.length) {
				$items.each((i, el) => {
					const $item = $(el);
					const id = $item.data(dataSelectors.id);
					if (ids.indexOf(id) === -1) {
						$item.remove();
					}
				});
			}
		},

		_local($list) {
			const ids = module.update.getIds($list);
			const listId = $list.data(dataSelectors.listId);
			const oldIds = module.localStorage.getList(listId);
			const missingIds = module.update._getMissingIds(oldIds, ids);
			const newIds = module.update._getMissingIds(ids, oldIds);
			module.localStorage.setList(listId, ids);

			if (missingIds.length) {
				publish(publications.localRemoved, [listId, missingIds]);
				missingIds.forEach(id => module.toggle.updateDisplayById(id, false, false));
			}
			if (newIds.length) {
				publish(publications.localAdded, [listId, newIds]);
			}
			module.update.showPlaceholderIfListEmpty($list, ids);
		},

		_isListEmpty($list, ids) {
			if (typeof ids === 'undefined') {
				ids = module.update.getIds($list);
			}
			return ids.length === 0;
		},

		showPlaceholderIfListEmptySubscription(listId) {
			const $lists = $(selectors.list);
			const $thisList = $lists.filter((i, el) => $(el).data(dataSelectors.listId) === listId);
			const ids = module.localStorage.getList(listId);
			module.update.showPlaceholderIfListEmpty($thisList, ids);
		},

		showPlaceholderIfListEmpty($list, ids) {
			const isEmpty = module.update._isListEmpty($list, ids);
			const placeholderId = $list.data(dataSelectors.placeholderId);
			const $placeholder = $(`#${placeholderId}`);
			if (isEmpty) {
				$placeholder.show();
				$list.hide();
			} else {
				$placeholder.hide();
				$list.show();
			}
			return isEmpty;
		},

		deleteEvent(e) {
			const $item = $(e.target).closest(selectors.item);
			module.update._delete($item);
		},

		_delete($item) {
			const $list = $item.closest(selectors.list);
			$item.remove();
			module.update._update($list);
		},

		_fetchSuccess: ($list, ids, method) => data => {
			const listId = $list.data(dataSelectors.listId);
			const results = module.update._buildResults(listId, data);
			const templateId = $list.data(dataSelectors.listTemplate);
			const $template = $(`#${templateId}`);
			const template = $template.html();
			module.update._renderList($list, results, template);
		},

		_fetchError: () => {
			publish(publications.error, 'Oops, an error occurred');
		},

		_buildResults(listId, data) {
			const results = [];
			const allDocs = data.combinedDocuments;
			const list = module.localStorage.getList(listId);
			list.forEach(listItem => {
				let doc = null, file = null;
				const idSplit = (listItem + '').match(/(.+)\|(.+)/);
				if (idSplit) {
					const docId = idSplit[1];
					const fileId = idSplit[2];
					doc = allDocs.filter(el => (el.Key + '') === docId);
					if (doc && doc.length) {
						doc = doc[0];
						file = doc.Files.filter(el => (el.File.Id + '') === fileId);
						if (file && file.length) {
							file = file[0];
							results.push({
								Name: `${doc.Name} (${file.Type})`,
								Id: `${doc.Key}|${file.File.Id}`
							});
						}
					}
				} else {
					doc = allDocs.filter(el => {
						const isDocument = !!el.File;
						if (isDocument) {
							return (el.File.Id + '') === (listItem + '');
						}
						return false;
					});
					if (doc && doc.length) {
						doc = doc[0];
						results.push({
							Id: doc.File.Id,
							Name: doc.Name
						});
					}
				}
			});
			return results;
		},

		_renderList($list, list, template) {
			const listId = $list.data(dataSelectors.listId);
			list = list || [];
			const ids = list.map(a => a.Id);
			const templateData = { items: list };
			template = template.replace(/\r/g, '');
			const html = Mustache.render(template, templateData);
			$list.html(html);
			module.cache.create($list);
			module.update.showPlaceholderIfListEmpty($list, ids);
			module.localStorage.setList(listId, ids);
		}
	},

	cache: {
		/*
		The ID cache is used to remember the state of a list when
		it was last loaded or saved, so we can prevent updates
		when the user has interacted with the list but its state
		has not changed. For example, swapping two items' positions
		then swapping them back to their original positions again.
		We also use a cache of the markup to revert changes in the
		case of an error.
		*/
		create($list) {
			$list.data(dataSelectors.cache, $list.html());
			$list.data(dataSelectors.idCache, module.update.getIds($list));
		},
		clear($list) {
			$list.removeData(dataSelectors.cache);
			$list.removeData(dataSelectors.idCache);
		},
		restore($list) {
			$list.html($list.data(dataSelectors.cache));
			$list.show();
			publish(publications.lazyload, { html: $list });
		}
	},

	util: {
		isLocal(i, el) {
			const $el = $(el);
			let method;
			if ($el.is(selectors.toggle)) {
				method = module.toggle.getMethod($el);
			} else if ($el.is(selectors.list)) {
				method = module.update.getMethod($el);
			}
			return method === Methods.LOCAL;
		}
	},

	localStorage: {
		getToggleValue($toggle) {
			let list = $toggle.data(dataSelectors.listId);
			const id = $toggle.data(dataSelectors.id);
			list = module.localStorage.getList(list);
			return list.indexOf(id) !== -1;
		},

		getList(id) {
			if (!localStorageSupport) return [];
			let list = localStorage.getItem(id);
			return list ? JSON.parse(list) : [];
		},

		setList(id, list) {
			if (localStorageSupport) {
				localStorage.setItem(id, JSON.stringify(list));
			}
		}
	}
};

export { module as UserManagedList };
